import FullScreenWrapper from './FullScreenWrapper';

export default FullScreenWrapper;
